import { BasicAuditReturn } from "./Audits/AuditResults/basic-audit-return";
import { DDL } from "./ddl";
import { AuditLocation } from "./Locations/audit-location";

export class BasicFilters{
    public Locations: AuditLocation[] = [];
        public AuditTypes: DDL[] = [];
        public Frequencies: DDL[] = [];
        public Audits: BasicAuditReturn[] = [];
        constructor(values: Object = {}) {
            Object.assign(this, values);
            if (values.hasOwnProperty('Locations')) {
                this.Locations = [];
                ((values as BasicFilters)['Locations'] as AuditLocation[]).forEach(element => {
                    this.Locations.push(new AuditLocation(element));
                });
            }
            if (values.hasOwnProperty('AuditTypes')) {
                this.AuditTypes = [];
                ((values as BasicFilters)['AuditTypes'] as DDL[]).forEach(element => {
                    this.AuditTypes.push(new DDL(element));
                });
            }
            if (values.hasOwnProperty('Frequencies')) {
                this.Frequencies = [];
                ((values as BasicFilters)['Frequencies'] as DDL[]).forEach(element => {
                    this.Frequencies.push(new DDL(element));
                });
            }
            if (values.hasOwnProperty('Audits')) {
                this.Audits = [];
                ((values as BasicFilters)['Audits'] as BasicAuditReturn[]).forEach(element => {
                    this.Audits.push(new BasicAuditReturn(element));
                });
            }
        }
}